import _ from 'lodash';
import {openDB, deleteDB, wrap, unwrap} from 'idb';
import syncConfig from '../offline/sync.config.js';
import stringHash from 'string-hash';

/*
 * This is application specific Middleware and will process only GET_ALL_TASKS action
 * Responsibilities:
 * If app is offline, update the api url to remove the pagination in querystring and include only category of allTasks(2)
 * If app is online, then get tasklist from idb. If empty create with default values
 */
const offlineHandlers = (config) => (store) => (next) => (action) => {
	const __NAME = 'Offline Response Middleware',
		UPDATE_APP_ONLINE_STATE = 'UPDATE_APP_ONLINE_STATE',
		API_ERRORS = 'API_ERRORS';

	if (
		action.type === UPDATE_APP_ONLINE_STATE &&
		action.meta &&
		action.meta.offlinemonitor
	) {
		action.type = 'SET_CONNECTIVITY_STATE';
		return next(action);
	}

	const appOnlineState = store.getState().apponlinestate;
	if (_.isBoolean(appOnlineState) && appOnlineState) {
		return next(action);
	}

	if (!(action.meta && action.meta.api)) {
		return next(action);
	}

	// skip to next middleware for API_ERROR actionset
	if (action.type === API_ERRORS) {
		return next(action);
	}

	const ONLINE_DB = 'ONLINE_DB',
		OFFLINE_DB = 'OFFLINE_DB';

	const dbPromise = openDB('canvas-idb', 1, {
		upgrade(db) {
			db.createObjectStore(ONLINE_DB);
			db.createObjectStore(OFFLINE_DB);
		}
	});

	const idbKeyval = {
		async get(key) {
			return (await dbPromise).get(ONLINE_DB, key);
		},
		async getOffline(key) {
			return (await dbPromise).get(OFFLINE_DB, key);
		},
		async set(key, val) {
			return (await dbPromise).put(ONLINE_DB, val, key);
		},
		async setOffline(key, val) {
			return (await dbPromise).put(OFFLINE_DB, val, key);
		},
		async delete(key) {
			return (await dbPromise).delete(ONLINE_DB, key);
		},
		async clear() {
			return (await dbPromise).clear(ONLINE_DB);
		},
		async keys() {
			return (await dbPromise).getAllKeys(ONLINE_DB);
		}
	};

	if (!config) {
		const configMsg = `
		Config unavailable.
		The AD package requires config to get the authorization token for the api call.`;
		console.log(configMsg);
	}
	async function RemoveTaskFromOfflineEvidences(docId,taskId)
	{
		let engagementIdFragment = action.meta.api.url.toLowerCase().indexOf('/engagements/')> -1 ? 
		action.meta.api.url.toLowerCase().split('/engagements/')[1] :
		action.meta.api.url.toLowerCase().split('engagementid=')[1];
		let engagementId = engagementIdFragment.split('/')[0].split('&')[0];

		let offlineDocs = await idbKeyval.get(engagementId + '_' + 'offlineEvidences');
		let currentDocs = [...offlineDocs.documents];
		let currentdoc = currentDocs.find((cd) => cd.id === docId);
		currentdoc.tasks = currentdoc.tasks.filter((d)=> d.id !== taskId);					

		//delete before adding			
		await idbKeyval.set(engagementId + '_' + 'offlineEvidences', {
			documents: [...currentDocs]
		});
		console.log('📴📴📴offlineDOcs', currentDocs);
	};

	async function AddTaskToOfflineEvidences(docId,taskId,taskTypeId)
	{
		let engagementIdFragment = action.meta.api.url.toLowerCase().indexOf('/engagements/')> -1 ? 
			action.meta.api.url.toLowerCase().split('/engagements/')[1] :
			action.meta.api.url.toLowerCase().split('engagementid=')[1];
		let engagementId = engagementIdFragment.split('/')[0].split('&')[0];

		let task =[];						
			let offlineDocs = await idbKeyval.get(engagementId + '_' + 'offlineEvidences');
			let currentDocs = [...offlineDocs.documents];
			let currentdoc = currentDocs.find((cd) => cd.id === docId);

			if(currentdoc)
			{
				task =[...currentdoc.tasks];
				task.push({id: taskId,taskTypeId: taskTypeId});			
				currentdoc.tasks = task;
			}					

			//delete before adding			
			await idbKeyval.set(engagementId + '_' + 'offlineEvidences', {
				documents: [...currentDocs]
			});
			console.log('📴📴📴offlineDOcs', currentDocs);
	};
 
	switch (action.type) {
		case 'ASSOCIATE_TASK_DOCUMENTS':
			console.log('🎫🎫🎫🎫Handling offline actions');
			// find the document with the docID in offline_evidences
			// assign document to action.response
			let data = action.meta.api.data;
			action.response = {
				documentId: data.DocumentId,
				engagementId: data.EngagementId,
				documentTypeId: data.DocumentTypeId,
				documentName: data.DocumentName,
				fileExt: data.Documentfileext,
				parentName: data.parentName,
				inProgress: false,
				// if source engagement id is null document belongs to same engagement and not linked, pass current engagement id
				sourceEngagementId: data.SourceEngagementID,
				// relate: 1
				// delete: 2
				isAssociated: action.meta.api.data.operationType === 1,
				approvals:data.approvals
			};

	         AddTaskToOfflineEvidences(data.DocumentId,action.meta.api.data.TaskId,action.meta.api.data.taskTypeId)

			// associate offline documents when post action just return
			if (action.response.isAssociated) {
				return next(action);
			}

			// handle offline remove from task action
			(() => {

				// remove the task relation from offline evidences
				RemoveTaskFromOfflineEvidences(action.response.documentId,action.meta.api.data.TaskId);

				let docapi = action.meta.api.url;
				let docurl = docapi.split('/' + action.meta.api.data.DocumentId)[0];
				let _docid = stringHash(docurl.toLowerCase() + 'POST');
				return new Promise((resolve, reject) => {
					idbKeyval.getOffline(_docid).then((docs) => {
						if (
							docs &&
							docs.find(
								(d) =>
									d.meta.api.data.DocumentId == action.meta.api.data.DocumentId
							)
						) {
												
 						// offline added documents and delete in offline then remove that action from hash
							console.log('Handling offline taskdocuments');
							var documents = jQuery.grep(docs, function(item) {
								return (
									item.meta.api.data.DocumentId !=
									action.meta.api.data.DocumentId
								);
							});
							idbKeyval.setOffline(_docid, [...documents]);
							// Adding the new key _id to the sync_keys record in offline_db
							// This is added as a workaround for Edge browser: Unsupported getAll indexedDB API.
							idbKeyval.getOffline('sync_keys').then((ks) => {
								let syncKeys = ks || [];
								idbKeyval.setOffline('sync_keys', _.union(syncKeys, [_docid]));
							});
							resolve();
						} else {
							// insert remove taskdocument action for online documents.
							console.log('Handling online taskdocuments');
							let _removeDocId = stringHash(docurl.toLowerCase() + 'DELETE');
							idbKeyval.getOffline(_removeDocId).then((rd) => {
								if (rd) {
									idbKeyval.setOffline(_removeDocId, [...rd, action]);
								} else {
									idbKeyval.setOffline(_removeDocId, [action]);
								}
								// Adding the new key _id to the sync_keys record in offline_db
								// This is added as a workaround for Edge browser: Unsupported getAll indexedDB API.
								idbKeyval.getOffline('sync_keys').then((ks) => {
									let syncKeys = ks || [];
									idbKeyval.setOffline(
										'sync_keys',
										_.union(syncKeys, [_removeDocId])
									);
								});
								resolve();
							});
						}
					});
				});
			})().then((e) => {
				return next(action);
			});
			break;
		case 'ADD_APPROVAL_FOR_DOCUMENT':
			console.log('Handling offline Post approval');
			let userPreferences = store.getState().userPreferences;
			let approval = action.meta.api.data;
			let d = new Date();
			action.response = {
				documentId: approval.documentId,
				isPreparer: approval.isPreparer,
				isLatest: true,
				isFromLoggedInUser: true,
				taskId: approval.TaskId,
				canbeRemoved: 0,
				approvalStatusID: 1,
				approvalUserId: userPreferences.id,
				userInitials: userPreferences.initials,
				name: userPreferences.firstName + ' ' + userPreferences.lastName,
				createDate: d,
				approvalId: d.getMinutes() + d.getSeconds() + d.getMilliseconds()
			};
			return next(action);
		case 'REMOVE_APPROVAL_FOR_DOCUMENT':
			console.log('Handling offline Delete approval');
			let api = action.meta.api.url;
			//api.split(/[/ ]+/).pop()
			let url = api.split('/' + action.meta.api.data.approvalId)[0];
			let _id = stringHash(url.toLowerCase() + 'POST');

			(() => {
				return new Promise((resolve, reject) => {
					idbKeyval.getOffline(_id).then((d) => {
						if (
							d &&
							d.find(
								(a) => a.response.approvalId == action.meta.api.data.approvalId
							)
						) {
							// offline added approvals and delete in offline then remove that action from hash
							console.log('Handling offline approvals');
							var approvals = jQuery.grep(d, function(item) {
								return (
									item.response.approvalId != action.meta.api.data.approvalId
								);
							});
							idbKeyval.setOffline(_id, [...approvals]);
							// Adding the new key _id to the sync_keys record in offline_db
							// This is added as a workaround for Edge browser: Unsupported getAll indexedDB API.
							idbKeyval.getOffline('sync_keys').then((ks) => {
								let syncKeys = ks || [];
								idbKeyval.setOffline('sync_keys', _.union(syncKeys, [_id]));
							});
							resolve();
						} else {
							// insert remove approval action for online approvals.
							console.log('Handling online approvals');
							let removeApprovalHash = stringHash(
								url.toLowerCase() + action.meta.api.method
							);
							idbKeyval.getOffline(removeApprovalHash).then((da) => {
								if (da) {
									idbKeyval.setOffline(removeApprovalHash, [...da, action]);
								} else {
									idbKeyval.setOffline(removeApprovalHash, [action]);
								}
								// Adding the new key _id to the sync_keys record in offline_db
								// This is added as a workaround for Edge browser: Unsupported getAll indexedDB API.
								idbKeyval.getOffline('sync_keys').then((ks) => {
									let syncKeys = ks || [];
									idbKeyval.setOffline(
										'sync_keys',
										_.union(syncKeys, [removeApprovalHash])
									);
								});
								resolve();
							});
						}
					});
				});
			})().then((e) => {
				return next(action);
			});
			break;

		case 'GET_TASK_DOCUMENT_RELATE':
			//get the documents from the store
			let taskDocuments = store.getState().taskDocuments;
			let updatedDocs =[];
			//Map through each document in relate files modal
			 action.response.documents.map((doc) => {
				// find if the document taskdocuments is present in the modal
				let isAssociated = doc.tasks && doc.tasks.find((d) => d.id === taskDocuments.taskId)
				
				// update the isAssociated property
				var newdoc = {
					documentTypeId : doc.documentTypeId,
					fileExt:doc.fileExt,
					id: doc.id,
					documentId: doc.id,
					documentName: doc.documentName,
					isAssociated:!_.isEmpty(isAssociated),
					sourceEngagementId:doc.engagementId,
					approvals:doc.approvals
				 };
				updatedDocs.push(newdoc);				
			});

			action.response.data = updatedDocs;

			return next(action);
			break;
	}

	return next(action);
};

export default offlineHandlers;